import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import i18n from '../../i18n';
import { primaryFont, textStyles, colors, common } from '../../assets/theme';
import TwoSectionContainer from '../../components/twoSectionContainer/twoSectionContainer';
import { Grid } from '@material-ui/core';
import map from '../../assets/icons/customerFunction/map.svg';
import document from '../../assets/icons/customerFunction/document.svg';
import moment from 'moment';
import { handleDownloadFile } from '../../shared/utils';
import Spinner from '../../components/spinner/spinner';
import { getDocumentDownloaded } from '../../actions/quoteActions';

import { Helmet } from 'react-helmet';
import { getAllDocuments } from '../../actions/myAccountActions';
import { cmsMap } from '../../services/cmsIdMap';
import { MYACCOUNTROUTES } from '../../shared/constants';
import SpinnerOverlay from '../../components/spinnerOverlay';
import * as ENV from '../../const';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const DetailedPolicy = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const selectedPolicy = useSelector((state) => state.myAccount.selectedPolicy);
    const documents = useSelector((state) => state.myAccount.documents);
    const isDocumentsLoading = useSelector((state) => state.myAccount.isDocumentsLoading);
    const downloadedFile = useSelector((state) => state.quote.downloadedDocument);
    const images = useSelector((state) => state.cms.allPageContents.coverages);
    const pageContents = useSelector(
        (state) => state.cms.allPageContents[cmsMap.detailedPolicyScreen]
    );

    const [isPolicySelected, setIsPolicySelected] = useState(true);
    const [isGridSelected, setIsGridSelected] = useState(true);
    const [policySelected, setPolicySelected] = useState(selectedPolicy);

    const [counter, setCounter] = useState(1);
    useEffect(() => {
        if (!Object.keys(selectedPolicy).length) {
            history.push(MYACCOUNTROUTES.MYACCOUNT);
        }
    }, []);

    useEffect(() => {
        // const partyId = window.sessionStorage.getItem('partyId');
        let docsPayload = {
            customerId: null,
            documentCategory: null,
            submissionId: policySelected.submissionId,
        };
        if (
            counter < 6 &&
            !documents.find((doc) => doc.documentType === 'POLICY_SCHEDULE') &&
            !isPolicySelected
        ) {
            const timeout = setTimeout(() => {
                dispatch(getAllDocuments(docsPayload));
                setCounter(counter + 1);
            }, 10000);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [counter, isPolicySelected]);

    useEffect(() => {
        setPolicySelected(selectedPolicy);
    }, [selectedPolicy]);

    const handleGoBack = () => {
        history.push(MYACCOUNTROUTES.MYACCOUNT);
    };

    return (
        <>
            <Helmet>
                <title>Policy Details</title>
                <meta name="description" content="Detailed description of the policy." />
            </Helmet>
            {!pageContents?.policy?.TitleText && <SpinnerOverlay backgroundColor="white" />}
            <TwoSectionContainer
                blueSectionStyle={css(styles.blueSectionStyle)}
                handleGoBack={() => {
                    handleGoBack();
                }}
                backgroundColor={pageContents && pageContents.LPBackgroundColor}
                detailedPolicy
                detailedPolicyObj={{
                    vehicleName:
                        policySelected &&
                        policySelected.vehicles &&
                        policySelected.vehicles.length &&
                        policySelected.vehicles[0].make.value,
                    yearMakeModel:
                        (policySelected &&
                            policySelected.vehicles &&
                            policySelected.vehicles.length &&
                            policySelected.vehicles[0].model.value) +
                        ' ' +
                        (policySelected &&
                            policySelected.vehicles &&
                            policySelected.vehicles.length &&
                            policySelected.vehicles[0].spec.value) +
                        ' ' +
                        (policySelected &&
                            policySelected.vehicles &&
                            policySelected.vehicles.length &&
                            policySelected.vehicles[0].year.value),
                    policyNo: policySelected && policySelected.policyId,
                    startDate: moment(policySelected && policySelected.policyTermStartDate)
                        .utc()
                        .format('DD MMMM YYYY'),
                    endDate: moment(policySelected && policySelected.policyTermEndDate)
                        .utc()
                        .format('DD MMMM YYYY'),
                    annualPremium:
                        policySelected?.premiumDetails?.TotalPackageVatPremium?.amount?.toLocaleString(),
                    sumInsured: policySelected?.vehicles[0]?.insuredAmount?.toLocaleString(),
                    currency: policySelected?.premiumDetails?.TotalPackageVatPremium?.currency,
                }}
                rightPanelClassName={`right-panel-coverages ${
                    i18n.language === 'ar' ? 'right-panel-arabic-coverages' : ''
                }`}
                history={history}
            >
                <Grid container className={css(styles.rightContainer)}>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid
                                item
                                xs={2}
                                md={2}
                                className={css(styles.policyIcon)}
                                onClick={() => setIsPolicySelected(true)}
                            >
                                <Grid container style={{ cursor: 'pointer' }}>
                                    <Grid item xs={12}>
                                        <img
                                            className={css(styles.tabIcons)}
                                            src={
                                                isPolicySelected
                                                    ? `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.policy?.ImageEnable?.image?.contentUrl}`
                                                    : `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.policy?.ImageDisable?.image?.contentUrl}`
                                            }
                                            alt={pageContents?.policy?.TitleText}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className={`${css(
                                            isPolicySelected
                                                ? styles.tabText
                                                : styles.tabTextDisabled
                                        )} ${i18n.language === 'ar' ? 'arabic-plain' : ''}`}
                                    >
                                        {pageContents?.policy?.TitleText}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                xs={2}
                                md={10}
                                style={{ paddingLeft: '2%' }}
                                onClick={() => setIsPolicySelected(false)}
                            >
                                <Grid container style={{ cursor: 'pointer' }}>
                                    <Grid item xs={12}>
                                        <img
                                            className={css(styles.tabIcons)}
                                            src={
                                                isPolicySelected
                                                    ? `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.policy?.ImageDisable?.image?.contentUrl}`
                                                    : `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.policy?.ImageEnable?.image?.contentUrl}`
                                            }
                                            alt={pageContents?.docs?.TitleText}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        className={`${css(
                                            isPolicySelected
                                                ? styles.tabTextDisabled
                                                : styles.tabText
                                        )} ${i18n.language === 'ar' ? 'arabic-plain' : ''}`}
                                    >
                                        {pageContents?.docs?.TitleText}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {isPolicySelected && (
                        <>
                            <Grid item xs={12} className={css(styles.coverageCard)}>
                                <div className={css(styles.cardContainer)}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <div
                                                className={`${css(styles.coverageSection)} ${
                                                    i18n.language === 'ar' ? 'arabic-bold' : ''
                                                }`}
                                            >
                                                <div>
                                                    <img
                                                        className={css(styles.umbrella)}
                                                        src={`${ENV.CMS_BASE_IMAGE_URL}${pageContents?.coverages?.GroupIcon?.image?.contentUrl}`}
                                                        alt="umbrella-icon"
                                                    />
                                                </div>
                                                <div>{pageContents?.coverages?.TitleText}</div>
                                            </div>
                                            <div
                                                className={`${css(styles.coverageName)} ${
                                                    i18n.language === 'ar' ? 'arabic-bold' : ''
                                                }`}
                                            >
                                                {policySelected &&
                                                policySelected.offering &&
                                                policySelected.offering.offeringId !== 'TPL'
                                                    ? pageContents?.comprehensive?.IconText
                                                    : ''}
                                                {policySelected &&
                                                policySelected.offering &&
                                                policySelected.offering.offeringId !== 'TPL' ? (
                                                    <span className={css(styles.packageType)}>
                                                        (
                                                        {policySelected &&
                                                            policySelected.offering &&
                                                            policySelected.offering.offeringName}
                                                        )
                                                    </span>
                                                ) : (
                                                    <span className={css(styles.packageType)}>
                                                        {policySelected &&
                                                            policySelected.offering &&
                                                            policySelected.offering.offeringName}
                                                    </span>
                                                )}
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <hr className={css(styles.divider)} />
                                        </Grid>
                                        {policySelected?.offering?.coverages?.length &&
                                        policySelected.offering.coverages.find(
                                            (data) => data.category === 'BASE_COVERAGE'
                                        ) ? (
                                            <>
                                                <Grid
                                                    item
                                                    className={`${css(styles.sectionHeading)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {pageContents?.baseCoverage?.ControlValue}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container>
                                                        {policySelected?.offering?.coverages
                                                            .length &&
                                                            policySelected.offering.coverages.map(
                                                                (coverage, i) => (
                                                                    <Fragment key={i}>
                                                                        {'BASE_COVERAGE' ===
                                                                            coverage.category && (
                                                                            <Grid
                                                                                item
                                                                                xs={6}
                                                                                md={3}
                                                                                style={{
                                                                                    marginBottom: 15,
                                                                                }}
                                                                            >
                                                                                <Grid
                                                                                    container
                                                                                    className={css(
                                                                                        styles.coverageItems
                                                                                    )}
                                                                                >
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                    >
                                                                                        <img
                                                                                            className={css(
                                                                                                styles.coverageIcon
                                                                                            )}
                                                                                            src={
                                                                                                images?.length &&
                                                                                                images?.find(
                                                                                                    (
                                                                                                        data
                                                                                                    ) =>
                                                                                                        data.coverageId ===
                                                                                                        coverage.coverageId
                                                                                                )
                                                                                                    ?.src
                                                                                            }
                                                                                            alt={
                                                                                                coverage.coverageName
                                                                                            }
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        className={`${css(
                                                                                            styles.coverageTitle
                                                                                        )} ${
                                                                                            i18n.language ===
                                                                                            'ar'
                                                                                                ? 'arabic-plain'
                                                                                                : ''
                                                                                        }`}
                                                                                    >
                                                                                        {i18n.language ===
                                                                                        'ar'
                                                                                            ? coverage.coverageNameInArabic
                                                                                            : coverage.coverageName}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        )}
                                                                    </Fragment>
                                                                )
                                                            )}
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <hr className={css(styles.dashedLine)} />
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {policySelected?.offering?.coverages?.length &&
                                        policySelected.offering.coverages.find(
                                            (data) => data.category === 'ADDITIONAL_COVERAGE'
                                        ) ? (
                                            <>
                                                <Grid
                                                    item
                                                    className={`${css(styles.sectionHeading)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {pageContents?.additionalCoverage?.ControlValue}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container>
                                                        {policySelected &&
                                                            policySelected.offering &&
                                                            policySelected.offering &&
                                                            policySelected.offering.coverages
                                                                .length &&
                                                            policySelected.offering.coverages.map(
                                                                (items, i) => (
                                                                    <>
                                                                        {'ADDITIONAL_COVERAGE' ===
                                                                            items.category && (
                                                                            <Grid
                                                                                item
                                                                                xs={6}
                                                                                md={3}
                                                                                style={{
                                                                                    marginBottom: 15,
                                                                                }}
                                                                            >
                                                                                <Grid
                                                                                    container
                                                                                    className={css(
                                                                                        styles.coverageItems
                                                                                    )}
                                                                                >
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                    >
                                                                                        <img
                                                                                            className={css(
                                                                                                styles.coverageIcon
                                                                                            )}
                                                                                            src={
                                                                                                images.length &&
                                                                                                images?.find(
                                                                                                    (
                                                                                                        data
                                                                                                    ) =>
                                                                                                        data.coverageId ===
                                                                                                        items.coverageId
                                                                                                )
                                                                                                    ?.src
                                                                                            }
                                                                                            alt={
                                                                                                items.imageName
                                                                                            }
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        className={`${css(
                                                                                            styles.coverageTitle
                                                                                        )} ${
                                                                                            i18n.language ===
                                                                                            'ar'
                                                                                                ? 'arabic-plain'
                                                                                                : ''
                                                                                        }`}
                                                                                    >
                                                                                        {i18n.language ===
                                                                                        'ar'
                                                                                            ? items.coverageNameInArabic
                                                                                            : items.coverageName}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        )}
                                                                    </>
                                                                )
                                                            )}
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <hr className={css(styles.dashedLine)} />
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {policySelected?.offering?.coverages?.length &&
                                        policySelected.offering.coverages.find(
                                            (data) => data.category === 'OPTIONAL_COVERAGE'
                                        ) ? (
                                            <>
                                                <Grid
                                                    item
                                                    className={`${css(styles.sectionHeading)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {pageContents?.optionalCoverage?.ControlValue}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container>
                                                        {policySelected &&
                                                            policySelected.offering &&
                                                            policySelected.offering &&
                                                            policySelected.offering.coverages
                                                                .length &&
                                                            policySelected.offering.coverages.map(
                                                                (items, i) => (
                                                                    <>
                                                                        {'OPTIONAL_COVERAGE' ===
                                                                            items.category && (
                                                                            <Grid
                                                                                item
                                                                                xs={6}
                                                                                md={3}
                                                                                style={{
                                                                                    marginBottom: 15,
                                                                                }}
                                                                            >
                                                                                <Grid
                                                                                    container
                                                                                    className={css(
                                                                                        styles.coverageItems
                                                                                    )}
                                                                                >
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                    >
                                                                                        <img
                                                                                            className={css(
                                                                                                styles.coverageIcon
                                                                                            )}
                                                                                            src={
                                                                                                images.length &&
                                                                                                images?.find(
                                                                                                    (
                                                                                                        data
                                                                                                    ) =>
                                                                                                        data.coverageId ===
                                                                                                        items.coverageId
                                                                                                )
                                                                                                    ?.src
                                                                                            }
                                                                                            alt={
                                                                                                items.imageName
                                                                                            }
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        className={`${css(
                                                                                            styles.coverageTitle
                                                                                        )} ${
                                                                                            i18n.language ===
                                                                                            'ar'
                                                                                                ? 'arabic-plain'
                                                                                                : ''
                                                                                        }`}
                                                                                    >
                                                                                        {i18n.language ===
                                                                                        'ar'
                                                                                            ? items.coverageNameInArabic
                                                                                            : items.coverageName}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        )}
                                                                    </>
                                                                )
                                                            )}
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <hr className={css(styles.dashedLine)} />
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {policySelected?.offering?.coverages?.length &&
                                        policySelected.offering.coverages.find(
                                            (data) => data.category === 'SUM_INSURED_BASED'
                                        ) ? (
                                            <>
                                                <Grid
                                                    item
                                                    className={`${css(styles.sectionHeading)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {pageContents?.sumInsuredBased?.IconText}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container>
                                                        {policySelected &&
                                                            policySelected.offering &&
                                                            policySelected.offering &&
                                                            policySelected.offering.coverages
                                                                .length &&
                                                            policySelected.offering.coverages.map(
                                                                (items, i) => (
                                                                    <>
                                                                        {'SUM_INSURED_BASED' ===
                                                                            items.category && (
                                                                            <Grid
                                                                                item
                                                                                xs={6}
                                                                                md={3}
                                                                                style={{
                                                                                    marginBottom: 15,
                                                                                }}
                                                                            >
                                                                                <Grid
                                                                                    container
                                                                                    className={css(
                                                                                        styles.coverageItems
                                                                                    )}
                                                                                >
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                    >
                                                                                        <img
                                                                                            className={css(
                                                                                                styles.coverageIcon
                                                                                            )}
                                                                                            src={
                                                                                                images.length &&
                                                                                                images?.find(
                                                                                                    (
                                                                                                        data
                                                                                                    ) =>
                                                                                                        data.coverageId ===
                                                                                                        items.coverageId
                                                                                                )
                                                                                                    ?.src
                                                                                            }
                                                                                            alt={
                                                                                                items.imageName
                                                                                            }
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        className={`${css(
                                                                                            styles.coverageTitle
                                                                                        )} ${
                                                                                            i18n.language ===
                                                                                            'ar'
                                                                                                ? 'arabic-plain'
                                                                                                : ''
                                                                                        }`}
                                                                                    >
                                                                                        {i18n.language ===
                                                                                        'ar'
                                                                                            ? items.coverageNameInArabic
                                                                                            : items.coverageName}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        )}
                                                                    </>
                                                                )
                                                            )}
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <hr className={css(styles.dashedLine)} />
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {policySelected?.offering?.coverages?.length &&
                                        policySelected.offering.coverages.find(
                                            (data) => data.category === 'OTHERS_INCLUDED'
                                        ) ? (
                                            <>
                                                <Grid
                                                    item
                                                    className={`${css(styles.sectionHeading)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {pageContents?.othersIncluded?.IconText}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container>
                                                        {policySelected &&
                                                            policySelected.offering &&
                                                            policySelected.offering &&
                                                            policySelected.offering.coverages
                                                                .length &&
                                                            policySelected.offering.coverages.map(
                                                                (items, i) => (
                                                                    <>
                                                                        {'OTHERS_INCLUDED' ===
                                                                            items.category && (
                                                                            <Grid
                                                                                item
                                                                                xs={6}
                                                                                md={3}
                                                                                style={{
                                                                                    marginBottom: 15,
                                                                                }}
                                                                            >
                                                                                <Grid
                                                                                    container
                                                                                    className={css(
                                                                                        styles.coverageItems
                                                                                    )}
                                                                                >
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                    >
                                                                                        <img
                                                                                            className={css(
                                                                                                styles.coverageIcon
                                                                                            )}
                                                                                            src={
                                                                                                images.length &&
                                                                                                images?.find(
                                                                                                    (
                                                                                                        data
                                                                                                    ) =>
                                                                                                        data.coverageId ===
                                                                                                        items.coverageId
                                                                                                )
                                                                                                    ?.src
                                                                                            }
                                                                                            alt={
                                                                                                items.imageName
                                                                                            }
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        className={`${css(
                                                                                            styles.coverageTitle
                                                                                        )} ${
                                                                                            i18n.language ===
                                                                                            'ar'
                                                                                                ? 'arabic-plain'
                                                                                                : ''
                                                                                        }`}
                                                                                    >
                                                                                        {i18n.language ===
                                                                                        'ar'
                                                                                            ? items.coverageNameInArabic
                                                                                            : items.coverageName}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        )}
                                                                    </>
                                                                )
                                                            )}
                                                    </Grid>
                                                </Grid>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </Grid>
                                </div>
                            </Grid>
                            <Grid item xs={12} className={css(styles.coverageCard)}>
                                <div className={css(styles.cardContainer)}>
                                    <Grid container style={{ margin: '10px 0px' }}>
                                        <Grid item xs={12}>
                                            <div className={css(styles.coverageSection)}>
                                                <div>
                                                    <img
                                                        className={css(styles.umbrella)}
                                                        src={`${ENV.CMS_BASE_IMAGE_URL}${pageContents?.carDetails?.GroupTitleImageirvs?.image?.contentUrl}`}
                                                        alt="car-icon"
                                                    />
                                                </div>
                                                <div
                                                    className={
                                                        i18n.language === 'ar' ? 'arabic-align' : ''
                                                    }
                                                >
                                                    {pageContents?.carDetails?.GroupTitle}
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container className={css(styles.segment)}>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    className={`${css(styles.leftSegment)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {
                                                        pageContents?.carDetails?.chassisNumber
                                                            ?.AttributeValue
                                                    }
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    className={css(styles.rightSegment)}
                                                >
                                                    {policySelected &&
                                                        policySelected.vehicles &&
                                                        policySelected.vehicles.length &&
                                                        policySelected.vehicles[0].vin}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <hr
                                                        style={{ margin: '10px 0' }}
                                                        className={css(styles.dashedLine)}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={6}
                                                    className={`${css(styles.leftSegment)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {
                                                        pageContents?.carDetails?.plateNumCategory
                                                            ?.AttributeValue
                                                    }
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    className={css(styles.rightSegment)}
                                                >
                                                    {policySelected &&
                                                        policySelected.vehicles &&
                                                        policySelected.vehicles.length &&
                                                        policySelected.vehicles[0]
                                                            .regulatoryFields &&
                                                        policySelected.vehicles[0].regulatoryFields
                                                            .plateNumber}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                            <Grid item xs={12} className={css(styles.coverageCard)}>
                                <div className={css(styles.cardContainer)}>
                                    <Grid container style={{ margin: '10px 0px' }}>
                                        <Grid item xs={12}>
                                            <div className={css(styles.coverageSection)}>
                                                <div>
                                                    <img
                                                        className={css(styles.umbrella)}
                                                        src={map}
                                                        alt="map-icon"
                                                    />
                                                </div>
                                                <div
                                                    className={
                                                        i18n.language === 'ar' ? 'arabic-align' : ''
                                                    }
                                                >
                                                    {pageContents?.otherDetails?.GroupTitle}
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container className={css(styles.segment)}>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    className={`${css(styles.leftSegment)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {
                                                        pageContents?.otherDetails
                                                            ?.geographicalLimit?.AttributeValue
                                                    }
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    className={css(styles.rightSegment)}
                                                >
                                                    {policySelected &&
                                                        policySelected.ccmDocumentsDetails &&
                                                        policySelected.ccmDocumentsDetails
                                                            .EN_COUNTRY}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <hr
                                                        style={{ margin: '10px 0' }}
                                                        className={css(styles.dashedLine)}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={6}
                                                    className={`${css(styles.leftSegment)} ${
                                                        i18n.language === 'ar' ? 'arabic-plain' : ''
                                                    }`}
                                                >
                                                    {
                                                        pageContents?.otherDetails?.vehicleMortgage
                                                            ?.AttributeValue
                                                    }
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    className={css(styles.rightSegment)}
                                                >
                                                    {policySelected &&
                                                        policySelected.vehicles &&
                                                        policySelected.vehicles.length &&
                                                        policySelected.vehicles[0]
                                                            .regulatoryFields &&
                                                        policySelected.vehicles[0].regulatoryFields
                                                            .mortgage}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </>
                    )}
                    {/*Documents Segment*/}
                    {!isPolicySelected && (
                        <>
                            <Grid item xs={12} className={css(styles.coverageCard)}>
                                <div className={css(styles.cardContainer)}>
                                    <div className={css(styles.viewOption)}>
                                        <span onClick={() => setIsGridSelected(true)}>
                                            <img
                                                src={
                                                    isGridSelected
                                                        ? `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.gridView?.ImageEnable?.image?.contentUrl}`
                                                        : `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.gridView?.ImageDisable?.image?.contentUrl}`
                                                }
                                                alt="grid-icon"
                                            />
                                        </span>
                                        <span onClick={() => setIsGridSelected(false)}>
                                            <img
                                                src={
                                                    isGridSelected
                                                        ? `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.listView?.ImageDisable?.image?.contentUrl}`
                                                        : `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.listView?.ImageEnable?.image?.contentUrl}`
                                                }
                                                alt="list-icon"
                                            />
                                        </span>
                                    </div>
                                    <Grid container className={css(styles.documentList)}>
                                        {isDocumentsLoading ? (
                                            <Grid item xs={12}>
                                                <Spinner spinnerStyle={css(styles.spinnerStyle)} />
                                            </Grid>
                                        ) : documents && documents.length ? (
                                            documents.map((doc, i) => (
                                                <Grid
                                                    key={doc.documentId}
                                                    item
                                                    xs={isGridSelected ? 0 : 12}
                                                    md={isGridSelected ? 0 : 12}
                                                    lg={isGridSelected ? 0 : 12}
                                                    className={css(styles.documentItem)}
                                                    onClick={() => {
                                                        dispatch(
                                                            getDocumentDownloaded(
                                                                doc.documentId,
                                                                (downloadedFile) => {
                                                                    handleDownloadFile(
                                                                        downloadedFile,
                                                                        doc.fileName
                                                                    );
                                                                }
                                                            )
                                                        );
                                                    }}
                                                >
                                                    <div
                                                        className={css(
                                                            isGridSelected
                                                                ? styles.documentContainer
                                                                : styles.documentContainerList
                                                        )}
                                                    >
                                                        <img
                                                            className={css(
                                                                isGridSelected
                                                                    ? styles.documentIcon
                                                                    : styles.documentIconListView
                                                            )}
                                                            src={document}
                                                            alt="document-icon"
                                                        />
                                                        <span
                                                            style={{
                                                                textAlign: !isGridSelected
                                                                    ? 'left'
                                                                    : 'center',
                                                                marginTop: !isGridSelected ? 0 : '',
                                                                paddingLeft: !isGridSelected
                                                                    ? 20
                                                                    : '',
                                                            }}
                                                            className={css(styles.documentName)}
                                                        >
                                                            {doc.fileName}
                                                        </span>
                                                    </div>
                                                </Grid>
                                            ))
                                        ) : (
                                            pageContents?.noDocumentsFound?.IconText
                                        )}
                                    </Grid>
                                </div>
                            </Grid>
                        </>
                    )}
                </Grid>
            </TwoSectionContainer>
        </>
    );
};

const styles = StyleSheet.create({
    spinnerStyle: {
        margin: '20px auto 0px auto',
    },
    documentIconListView: {
        width: 16,
        [common.mediaQuery.minXlg]: {
            width: 18,
        },
    },
    documentIcon: {
        width: 30,
        [common.mediaQuery.minXlg]: {
            width: 48,
        },
    },
    documentList: {
        marginBottom: 20,
    },
    viewOption: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '12px 0px',
        cursor: 'pointer',
    },
    documentName: {
        ...primaryFont.medium,
        fontSize: 14,
        lineHeight: '16px',
        marginTop: 10,
        color: colors.grey[700],
        width: '91%',
        [common.mediaQuery.minXlg]: {
            fontSize: 18,
            lineHeight: '26px',
        },
    },
    documentContainerList: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        height: 50,
        border: '1px solid #E3E3E6',
        paddingLeft: '4%',
        borderRadius: 4,
        cursor: 'pointer',
        [common.mediaQuery.minXlg]: {
            height: 60,
        },
    },
    documentContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: 120,
        height: 120,
        border: '1px solid #E3E3E6',
        borderRadius: 4,
        cursor: 'pointer',
        [common.mediaQuery.minXlg]: {
            width: 180,
            height: 180,
        },
    },
    tabIcons: {
        width: 28,
        height: 28,
        [common.mediaQuery.minXlg]: {
            width: 39,
            height: 39,
        },
    },
    packageType: {
        color: colors.grey[50],
    },
    coverageIcon: {
        // width: '25px',
    },
    segment: {
        ...primaryFont.book,
        fontSize: 14,
        lineHeight: '20px',
        [common.mediaQuery.minXlg]: {
            fontSize: 18,
            lineHeight: '26px',
        },
    },
    leftSegment: {
        color: colors.grey[50],
    },
    rightSegment: {
        textAlign: 'right',
        color: colors.staryBlack,
    },
    dashedLine: {
        borderStyle: 'dashed',
        borderTop: 0,
        borderRight: 0,
        borderLeft: 0,
        color: colors.grey[450],
        margin: '20px 0px',
    },
    divider: {
        borderTop: 0,
        borderRight: 0,
        borderLeft: 0,
        color: colors.grey[50],
        [common.mediaQuery.minSm]: {
            borderWidth: 2,
        },
    },
    coverageTitle: {
        ...primaryFont.book,
        fontSize: 14,
        lineHeight: '20px',
        marginTop: 10,
        color: colors.textFieldLabel,
        [common.mediaQuery.minXlg]: {
            fontSize: 18,
            lineHeight: '18px',
        },
    },
    sectionHeading: {
        ...primaryFont.medium,
        fontSize: 14,
        lineHeight: '18px',
        paddingBottom: 10,
        color: colors.darkblue,
        [common.mediaQuery.minXlg]: {
            fontSize: 18,
            lineHeight: '18px',
        },
    },
    coverageName: {
        ...primaryFont.medium,
        marginTop: 10,
        fontSize: 16,
        lineHeight: '20px',
        color: colors.darkblue,
        [common.mediaQuery.minMd]: {
            fontSize: 16,
            lineHeight: '25px',
        },
        [common.mediaQuery.minXlg]: {
            fontSize: '24px !important',
            lineHeight: '38px !important',
        },
    },
    coverageCard: {
        marginTop: 16,
    },
    coverageSection: {
        ...primaryFont.medium,
        display: 'flex',
        alignItems: 'center',
        fontSize: 16,
        lineHeight: '20px',
        color: colors.darkblue,
        [common.mediaQuery.minMd]: {
            fontSize: 16,
            lineHeight: '22px',
        },
        [common.mediaQuery.minXlg]: {
            fontSize: '24px !important',
            lineHeight: '32px !important',
        },
    },
    umbrella: {
        width: 24,
        height: 24,
        marginLeft: '-18%',
        [common.mediaQuery.minXlg]: {
            width: 32,
            height: 32,
        },
    },
    blueSectionStyle: {
        background:
            'transparent linear-gradient(146deg, #1F3563 0%, #4D6496 100%) 0% 0% no-repeat padding-box',
    },
    tabText: {
        ...primaryFont.book,
        fontSize: 14,
        lineHeight: '20px',
        color: colors.darkblue,
        [common.mediaQuery.minXlg]: {
            fontSize: 20,
            lineHeight: '28px',
        },
    },
    tabTextDisabled: {
        ...primaryFont.book,
        fontSize: 14,
        lineHeight: '20px',
        color: colors.grey[50],
        [common.mediaQuery.minXlg]: {
            fontSize: 20,
            lineHeight: '28px',
        },
    },
    policyIcon: {
        maxWidth: '100% !important',
        [common.mediaQuery.minSm]: {
            maxWidth: '10% !important',
        },
    },
    cardContainer: {
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '0px 3px 6px #00000029',
        borderRadius: 5,
        padding: '2% 5%',
    },
    coverageItems: {
        [common.mediaQuery.minMd]: {
            width: '97%',
        },
    },
    documentItem: {
        padding: '0 45px 25px 0',
        '@media (max-width: 767px)': {
            padding: '0 22px 25px 0 !important',
        },
    },
});

DetailedPolicy.propTypes = {};

export default DetailedPolicy;
